import React from 'react';
import './_headtohead.scss';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown } from '@fortawesome/free-solid-svg-icons'

library.add(faCaretDown)

class Headtohead extends React.Component {
  
  addDefaultSrcTeamA() {
    document.getElementById("image-team-a").style.backgroundImage = "url('https://fantasy-franchise.com/img/DEF.png')";
  }
  addDefaultSrcTeamB() {
    document.getElementById("image-team-b").style.backgroundImage = "url('https://fantasy-franchise.com/img/DEF.png')";
  }

  render() {
    let bgStyleA = {
      backgroundImage: `url(${this.props.teama.image})`
    };
    let bgStyleB = {
      backgroundImage: `url(${this.props.teamb.image})`
    };

    
    return ( 
      <div>
            <div className="row">
              <div className="col-6">
                <div className="team team-a">
                  <div className="totals">
                  <img src={this.props.teama.image} style={{ display: "none" }} onError={this.addDefaultSrcTeamA} alt="team-logo" />
                  <div id="image-team-a" className="image" style={ bgStyleA }></div>
                <select className="form-control team-selector teama" name="teama" onChange={this.props.teamSelect}>
                      <option value>Select First Team</option>
                      {this.props.owners.map((owner) => {
                        if (owner.status === 'active') {
                          return <option key={owner.id} value={owner.id}>{owner.fantasyname} ({owner.name})</option>
                        }
                        else {
                          return <option key={owner.id} value={owner.id}>Inactive - {owner.fantasyname} ({owner.name})</option>
                        }
                      })}
                      
                    </select><FontAwesomeIcon icon="caret-down"/>
                    <h2 className="record">{this.props.isMatch ? this.props.teama.record : '-'}</h2>
                  </div>
                
                </div>
              </div>
              <div className="col-6">
                <div className="team team-b">
                  <div className="totals">
                  <img src={this.props.teamb.image} style={{ display: "none" }} onError={this.addDefaultSrcTeamB} alt="team-logo" />  
                  <div id="image-team-b" className="image" style={ bgStyleB }></div>
                <select className="form-control team-selector teamb" name="teamb" onChange={this.props.teamSelect} >
                      <option value>Select Second Team</option>
                      {this.props.owners.map((owner) => {
                        if (owner.status === 'active') {
                          return <option key={owner.id} value={owner.id}>{owner.fantasyname} ({owner.name})</option>
                        }
                        else {
                          return <option key={owner.id} value={owner.id}>Inactive - {owner.fantasyname} ({owner.name})</option>
                        }
                      })}
                    </select><FontAwesomeIcon icon="caret-down"/>
                    <h2 className="record">{this.props.isMatch ? this.props.teamb.record : '-'}</h2>
                </div>
                
                </div>
              </div>
            </div>
                        
            <div className="container-fluid mb-4">
              <div className="row">
              <div className="col">
                <div className={"row team-stats " + (this.props.isMatch ? 'visible' : 'hidden')}>
                  <div className="col-6"><div>
                  <div className="nums">
                    <p><strong>current streak:</strong> {this.props.teama.currentstreak}</p>
                    <p><strong>highest win streak:</strong> {this.props.teama.highestwinstreak}</p>
                    <p><strong>Total Points:</strong> {(this.props.teama.totalPoints).toFixed(2)}</p>
                    <p><strong>Average Points:</strong> {(this.props.teama.totalPoints / (this.props.teamb.record + this.props.teama.record)).toFixed(2)}</p>
                    <p><strong>Highest Score:</strong> {this.props.teama.highestScore}</p>
                    <p><strong>Lowest Score:</strong> {this.props.teama.lowestScore}</p>
                    <p><strong>Biggest Win Margin:</strong>{this.props.teama.highestMargin}</p>
                    <p><strong>Smallest Win Margin:</strong> {this.props.teama.lowestMargin}</p>
                  </div>
                </div>
                </div>
                  <div className="col-6">
                  <div>
                  <div className="nums tmb">
                    <p> {this.props.teamb.currentstreak}</p>
                    <p>{this.props.teamb.highestwinstreak}</p>
                    <p> {(this.props.teamb.totalPoints).toFixed(2)}</p>
                    <p> {(this.props.teamb.totalPoints / (this.props.teamb.record + this.props.teama.record)).toFixed(2) }</p>
                    <p> {this.props.teamb.highestScore}</p>
                    <p> {this.props.teamb.lowestScore}</p>
                    <p>{this.props.teamb.highestMargin}</p>
                    <p> {this.props.teamb.lowestMargin}</p>
                  </div>
                </div>
                  
                  </div>
                </div>
              </div>
            </div>
            </div>  
          </div>)
  }
};

export default Headtohead;
